export enum CarrierFormType {

  CREATE     = 'CREATE',
  UPDATE     = 'UPDATE',
  UPDATE_OWN = 'UPDATE_OWN'
}
